import { Pipe, PipeTransform } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ExerciseHistory } from 'src/models/exercise.model';
import { ExerciseService } from 'src/services/exercise-service.service';

@Pipe({
    name: 'latestExerciseHistory',
    standalone: false
})
export class LatestExerciseHistoryPipe implements PipeTransform {
  constructor(private exerciseService: ExerciseService) {}

  transform(
    exerciseId: string,
    planId?: string
  ): Observable<ExerciseHistory | boolean> {
    if (!exerciseId) {
      return of(true); // Return an Observable that emits true if exerciseId is not provided
    }

    // If planId is provided, try to get the latest exercise history for that plan
    if (planId) {
      return from(
        this.exerciseService.getLatestExerciseHistoryByExerciseIdAndPlan(
          exerciseId,
          planId
        )
      ).pipe(
        switchMap((exercise) => {
          if (exercise) {
            return of(exercise); // Return the found exercise history for the specific plan
          } else {
            // If not found, fall back to getting the overall latest exercise history
            return from(
              this.exerciseService.getLatestExerciseHistoryByExerciseId(
                exerciseId
              )
            ).pipe(
              map((overallExercise) => {
                return overallExercise || true;
              }) // Return overall exercise history or true if not found
            );
          }
        }),
        catchError((error) => {
          console.error('Error fetching exercise:', error);
          return of(true); // Return an Observable that emits true in case of an error
        })
      );
    } else {
      // If no planId is provided, get the overall latest exercise history
      return from(
        this.exerciseService.getLatestExerciseHistoryByExerciseId(exerciseId)
      ).pipe(
        map((exercise) => exercise || true), // Return the overall exercise history or true if not found
        catchError((error) => {
          console.error('Error fetching exercise:', error);
          return of(true); // Return an Observable that emits true in case of an error
        })
      );
    }
  }
}
